import { useCallback, useState } from 'react'

const useImageUrl = () => {
  const [imageUrl, setImageUrl] = useState<string>('')

  const handleImageUrl = useCallback(
    (value: string) => {
      setImageUrl(value)
    },
    [setImageUrl]
  )

  return {
    imageUrl,
    handleImageUrl,
    setImageUrl,
  }
}

export default useImageUrl
